import SmileysGaugeDistributionWidget from './SmileysGaugeDistributionWidget';
export default SmileysGaugeDistributionWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/SmileysGaugeDistributionWidget/index.js